module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2014-08-22.5e12be79.md";